function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrderCard from "./OrderCard";
import SkeletonMyOrders from "../Common/Skeleton/SkeletonMyOrders";
import useData from "./data";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { loadMoreSvg } from "../DealsAndDiscounts/Components/ProductListing/svg";
import ZeroOrders from "./ZeroOrder";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Orders = function Orders(_ref) {
  var isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    winnreAuth = _ref.winnreAuth,
    appType = _ref.appType,
    _ref$showAppDownload = _ref.showAppDownload,
    showAppDownload = _ref$showAppDownload === void 0 ? false : _ref$showAppDownload;
  var history = useHistory();
  var isAuthenticated = useSelector(function (state) {
    return state.auth.isAuthenticated;
  });
  var _useState = useState("All"),
    _useState2 = _slicedToArray(_useState, 2),
    orderStatus = _useState2[0],
    setOrderStatus = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showOrderStatus = _useState4[0],
    setShowOrderStatus = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    expandedOrderId = _useState6[0],
    setExpandedOrderId = _useState6[1]; // Track the expanded order ID
  var changeStatus = function changeStatus(e) {
    setOrderStatus(e.target.id);
  };
  var _useData = useData({
      orderStatus: orderStatus,
      winnreAuth: winnreAuth,
      isRewards: isRewards,
      isPoints: isPoints,
      appType: appType
    }),
    orders = _useData.orders,
    loadingOrders = _useData.loadingOrders,
    currentPage = _useData.currentPage,
    totalPages = _useData.totalPages,
    setCurrentPage = _useData.setCurrentPage;
  var loadMoreHandler = function loadMoreHandler() {
    setCurrentPage(function (prev) {
      return prev + 1;
    });
  };
  var _toggleExpanded = function toggleExpanded(orderId) {
    setExpandedOrderId(function (prev) {
      return prev === orderId ? null : orderId;
    }); // Toggle expanded order
  };
  useEffect(function () {
    if ((orders === null || orders === void 0 ? void 0 : orders.length) === 0 && !loadingOrders && orderStatus === "All") {
      setShowOrderStatus(false);
    } else {
      setShowOrderStatus(true);
    }
  }, [orders, loadingOrders, orderStatus]);
  return /*#__PURE__*/_jsx("div", {
    children: isAuthenticated && /*#__PURE__*/_jsxs("div", {
      className: "w-full md:pl-3 lg:pl-7 2xl:pl-7 ",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("h1", {
          className: " font-Poppins text-xl md:text-2xl font-bold",
          children: "My Orders"
        }), /*#__PURE__*/_jsx("h3", {
          className: " font-Poppins pt-1 text-sm md:text-sm",
          children: "Manage your orders and reward points"
        })]
      }), showOrderStatus && /*#__PURE__*/_jsx("div", {
        className: "flex gap-x-2 md:gap-x-6 items-center mt-4",
        children: ["All", "Order Placed", "Shipped", "Delivered"].map(function (status) {
          return /*#__PURE__*/_jsx("div", {
            onClick: changeStatus,
            className: "cursor-pointer rounded-full px-4 py-2 text-[12px] md:text-[20px] lg:text-sm ".concat(orderStatus === status ? "text-white bg-primary" : "text-black bg-gray-200"),
            children: /*#__PURE__*/_jsx("h3", {
              id: status,
              children: status
            })
          }, status);
        })
      }), (orders === null || orders === void 0 ? void 0 : orders.length) == 0 && !loadingOrders && /*#__PURE__*/_jsx("div", {
        className: "mt-8",
        children: /*#__PURE__*/_jsx(ZeroOrders, {
          orderStatus: orderStatus,
          orders: orders,
          loadingOrders: loadingOrders
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "py-6",
        children: [loadingOrders && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-6",
            children: _toConsumableArray(Array(1).keys()).map(function (n) {
              return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4 mb-6",
            children: _toConsumableArray(Array(1).keys()).map(function (n) {
              return /*#__PURE__*/_jsx(SkeletonMyOrders, {}, n);
            })
          })]
        }), !loadingOrders && (orders === null || orders === void 0 ? void 0 : orders.map(function (order, index) {
          return /*#__PURE__*/_jsx(OrderCard, {
            order: order,
            isExpanded: expandedOrderId === order.id // Pass the expanded state
            ,
            toggleExpanded: function toggleExpanded() {
              return _toggleExpanded(order.id);
            }
          }, index);
        })), !loadingOrders && currentPage < totalPages && (orders === null || orders === void 0 ? void 0 : orders.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: " flex justify-center pb-7 mt-4 ",
          children: /*#__PURE__*/_jsx("button", {
            onClick: loadMoreHandler,
            className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-gray-500 border-[3px] border-gray-200 rounded mb-6",
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: ["Load More", loadMoreSvg]
            })
          })
        })]
      })]
    })
  });
};
export default Orders;